export default __webpack_public_path__ + "static/media/prooctane-utility-can.c22c137d.mp4";